// extracted by mini-css-extract-plugin
export default {"flex":"styles_flex__EV610","spaceBetween":"styles_spaceBetween__bSfSb","noJobs":"styles_noJobs__rMg1V","heading":"styles_heading__kO14d","card":"styles_card__nE7jH"};